import { useEffect } from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { SELECTION_BG_VAR, SELECTION_FG_VAR, tokenVar } from '@hivewatch/dark'

/**
 * Points the dark package's text-selection highlight at the palette matching
 * the app's current theme mode. The variables are set on <body> so both
 * DarkProvider scopes without an explicit colorScheme and content portaled
 * outside them pick the same palette up; unset (dark mode), scopes fall back
 * to the dark tokens and portaled content to the browser default.
 */
export const TextSelectionTheme = () => {
  const mode = useLightMode()

  useEffect(() => {
    const { style } = document.body
    if (mode === 'light') {
      style.setProperty(
        SELECTION_BG_VAR,
        tokenVar('colors.light.interactive.text-selection-bg')
      )
      style.setProperty(
        SELECTION_FG_VAR,
        tokenVar('colors.light.interactive.text-selection-fg')
      )
    } else {
      style.removeProperty(SELECTION_BG_VAR)
      style.removeProperty(SELECTION_FG_VAR)
    }
  }, [mode])

  return null
}
